import HybridCouponDetail from '../hybrid/pages/HybridCouponDetail/HybridCouponDetail.vue';
import HybridCouponMarketingList from '../hybrid/pages/HybridCouponMarketingList/hybrid.coupon.marketing.list.vue';
import HybridCouponMycoupons from '../hybrid/pages/HybridCouponMycoupons/hybrid.coupon.mycoupons.vue';
import HybridServicesAppointment from '../hybrid/pages/HybridServicesAppointment/hybrid.services.appointment.vue';
import HybridCouponServicesAppointmentSuccess from '../hybrid/pages/HybridCouponServicesAppointmentSuccess/hybrid.coupon.services.appointment.success.vue';
import HybridTestDemoPage from '../hybrid/pages/HybridTestDemoPage/hybrid.test.demo.page.vue';
import HybridCouponPaymentStatus from '../hybrid/pages/HybridCouponPaymentStatus/hybrid.coupon.payment.status.vue';
import HybridCouponShare from '../hybrid/pages/HybridCouponShare/HybridCouponShare.vue';
import HybridShareListPage from '../hybrid/pages/HybridShareListPage/hybrid.share.list.page.vue';
import MarketingTrendPage from '../hybrid/pages/MarketingTrendPage/marketing.trend.page.vue';
import MarketingWatchPage from '../hybrid/pages/MarketingWatchPage/marketing.watch.page.vue';
import HybridShareCommunityPage from '../hybrid/pages/HybridShareCommunityPage/hybrid.share.community.page.vue';
import HybridHousePriceEvaluate from '../hybrid/pages/HybridHousePriceEvaluatePage/hybrid.house.price.evaluate.page.vue';
import HybridSuccessPage from '../hybrid/pages/HybridSuccessPage/hybrid.success.page.vue';
import VDeliveryAcceptancePage from '../hybrid/pages/VDeliveryAcceptancePage/v.delivery.acceptance.page.vue';
import VAccountingCompanyPage from '../hybrid/pages/VAccountingCompanyPage/v.accounting.company.page.vue';
import VAccountingCustomerPage from '../hybrid/pages/VAccountingCustomerPage/v.accounting.customer.page.vue';
import VAccountingVendorPage from '../hybrid/pages/VAccountingVendorPage/v.accounting.vendor.page.vue';
import VRenewPage from '../hybrid/pages/VRenewPage/v.renew.page.vue';

export function hybridRoutesFactory() {
    const prefix = '/hybrid';
    // // prod guard
    // const routes = CallNative.isAndroid() || CallNative.isIos() ? [
    //     { path: `${prefix}/coupon/:id`, component: HybridCouponDetail },
    //     { path: `${prefix}/coupon/marketing/list`, component: HybridCouponMarketingList },
    //     { path: `${prefix}/coupon/my/coupons`, component: HybridCouponMycoupons },
    //     { path: `${prefix}/services/appointment`, component: HybridServicesAppointment },
    //     { path: `${prefix}/services/appointment/success`, component: HybridCouponServicesAppointmentSuccess },
    //     { path: `${prefix}/coupon/payment/:status`, component: HybridCouponPaymentStatus },
    //     { path: `${prefix}/test`, component: HybridTestDemoPage },
    //     { path: `${prefix}/coupon/share/:id`, component: HybridCouponShare }
    // ] : [];
    // dev
    const routes = [
        { path: `${prefix}/coupon/:id`, component: HybridCouponDetail },
        { path: `${prefix}/coupon/marketing/list`, component: HybridCouponMarketingList },
        { path: `${prefix}/coupon/my/coupons`, component: HybridCouponMycoupons },
        { path: `${prefix}/services/appointment/:insId`, component: HybridServicesAppointment },
        { path: `${prefix}/services/appointment/success`, component: HybridCouponServicesAppointmentSuccess },
        { path: `${prefix}/coupon/payment/:status`, component: HybridCouponPaymentStatus },
        { path: `${prefix}/test`, component: HybridTestDemoPage },
        { path: `${prefix}/coupon/share/:id`, component: HybridCouponShare },
        { path: `${prefix}/share/list`, component: HybridShareListPage },
        { path: `${prefix}/house/evaluate/price`, component: HybridHousePriceEvaluate },
        { path: `${prefix}/success`, component: HybridSuccessPage },
        {
            path: `${prefix}/marketing/trend`, component: MarketingTrendPage, meta: {
                title: 'Marketing Report'
            }
        },
        {
            path: `${prefix}/share/community`, component: HybridShareCommunityPage, meta: {
                title: 'Community Report'
            }
        },
        {
            path: `${prefix}/vendor/delivery/accept/:receive`, component: VDeliveryAcceptancePage, meta: {
                title: 'Delivery Acceptance'
            }
        },
        {
            path: `${prefix}/vendor/order/renew/:receive`, component: VRenewPage, meta: {
                title: 'Renew Services'
            }
        },
        {
            path: `${prefix}/vendor/accounting/company/:oid`, component: VAccountingCompanyPage, meta: {
                title: 'Accounting Summary Page'
            }
        },
        {
            path: `${prefix}/vendor/accounting/customer/:oid`, component: VAccountingCustomerPage, meta: {
                title: 'Accounting Summary Page'
            }
        },
        {
            path: `${prefix}/vendor/accounting/vendor/:oid`, component: VAccountingVendorPage, meta: {
                title: 'Accounting Summary Page'
            }
        }, {
            path: `${prefix}/marketing/watch`, component: MarketingWatchPage, meta: {
                title: 'Marketing Watch'
            }
        },
    ];
    return routes;
}
